module.exports = __webpack_public_path__ + "img/text_page_banner.5104589.png";